import {
	faChevronLeft,
	faEdit,
	faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useState } from "react";
import { store } from "react-notifications-component";
import ReactPaginate from "react-paginate";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Button,
	CardLink,
	Col,
	FormGroup,
	Input,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
	Spinner,
} from "reactstrap";
import { Dispatch } from "redux";
import { musicsAction } from "../../actions/musicsAction";
import updownArrows from "../../assets/images/up_down_arrows.svg";
import { getLoggedUserId } from "../../services/selectors/Accounts";
import { showAlert, showAlertWithBacktrack } from "../common/functions";
import OrderFilter from "./orderFilter";
import { UncontrolledTooltip } from "reactstrap";
import Select from "react-select";

interface MusicsProps {
	dispatch: Dispatch<any>;
	musicsData: any;
}

const MusicsList: React.SFC<MusicsProps> = ({ dispatch, musicsData }) => {
	const history = useHistory();

	const [selectedId, setSelectedId] = useState(-1);
	const [showModal, setShowModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [searchText, setSearch] = useState<string>("");
	const [debouncedSearch, setDebouncedSearch] = useState<string>("");
	const [columnSort, setColumnSort] = useState<any>(null);
	const [selectedStatus, setSelectedStatus] = useState<any>(null);
	const [rangeFilter, setRangeFilter] = useState<any>(null);
	const [tooltipOpen, setTooltipOpen] = useState(false);
	const toggle = () => setTooltipOpen(!tooltipOpen);

	React.useEffect(() => {
		const handler = setTimeout(() => {
			setCurrentPage(1);
			setDebouncedSearch(searchText);
		}, 400);
		return () => {
			clearTimeout(handler);
		};
	}, [searchText]);

	React.useEffect(() => {
		const body = {
			sortDirection: columnSort?.direction ?? "",
			sortColumn: columnSort?.column ?? "",
			pageNumber: currentPage,
			pageSize: 25,
			searchText: debouncedSearch,
			status: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
			fromOrderNo: rangeFilter?.from,
			toOrderNo: rangeFilter?.to,
		};
		setShowModal(true);
		dispatch(musicsAction.musicsGetByfilter(body));
	}, [debouncedSearch, columnSort]);

	const handleChnageStatus = (status) => {
		setSelectedStatus(status);
		const body = {
			sortDirection: columnSort?.direction ?? "",
			sortColumn: columnSort?.column ?? "",
			pageNumber: 1,
			pageSize: 25,
			searchText: debouncedSearch,
			status: isNaN(status) ? null : parseInt(status),
			fromOrderNo: rangeFilter?.from,
			toOrderNo: rangeFilter?.to,
		};
		setShowModal(true);
		setCurrentPage(1);
		dispatch(musicsAction.musicsGetByfilter(body));
	};

	const handleRangeFilter = (data) => {
		setRangeFilter(data);
		const body = {
			sortDirection: columnSort?.direction ?? "",
			sortColumn: columnSort?.column ?? "",
			pageNumber: 1,
			pageSize: 25,
			searchText: debouncedSearch,
			status: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
			fromOrderNo: data?.from,
			toOrderNo: data?.to,
		};
		setShowModal(true);
		setCurrentPage(1);
		dispatch(musicsAction.musicsGetByfilter(body));
	};

	const handleLoadDeleteModal = () => {
		dispatch(musicsAction.musicsDelete(selectedId));
		setShowModal(true);
		setShowDeleteModal(false);
	};

	if (musicsData && !musicsData.isLoading && musicsData.isListSuccess) {
		musicsData.isListSuccess = false;
		if (showModal) {
			setShowModal(false);
		}
	}

	if (
		selectedId >= 0 &&
		musicsData.isSuccess &&
		musicsData.isDeleteCompleted &&
		!musicsData.isError
	) {
		showAlert(musicsData.status, false);
		musicsData.isSuccess = false;
		musicsData.isDeleteCompleted = false;
		const body = {
			pageNumber:
				musicsData?.items?.musicAlbums?.length === 1
					? currentPage - 1
					: currentPage,
			pageSize: 25,
			searchText: debouncedSearch,
			sortDirection: columnSort?.direction ?? "",
			sortColumn: columnSort?.column ?? "",
			status: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
			fromOrderNo: rangeFilter?.from,
			toOrderNo: rangeFilter?.to,
		};
		setShowModal(true);
		dispatch(musicsAction.musicsGetByfilter(body));
		setCurrentPage(
			musicsData?.items?.musicAlbums?.length === 1
				? currentPage - 1
				: currentPage
		);
		setSelectedId(-1);
	}
	if (!musicsData.isSuccess && musicsData.isError) {
		if (musicsData.status === "Unauthorized") {
			history.push("/401");
		} else {
			showAlertWithBacktrack(musicsData.status, true, history);
		}
		musicsData.isError = false;
		setSelectedId(-1);
		if (showModal) {
			setShowModal(false);
		}
	}

	React.useEffect(() => {
		if (musicsData?.isUpdateStatus) {
			const body = {
				pageNumber: currentPage,
				pageSize: 25,
				searchText: debouncedSearch,
				sortDirection: columnSort?.direction ?? "",
				sortColumn: columnSort?.column ?? "",
				status: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
				fromOrderNo: rangeFilter?.from,
				toOrderNo: rangeFilter?.to,
			};
			setShowModal(true);
			dispatch(musicsAction.musicsGetByfilter(body));
			const alertMessage = musicsData?.status;
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				musicsData.isUpdateStatus = false;
				window.localStorage.setItem("alertMessage", "");
			}
		}
	}, [musicsData?.isUpdateStatus]);

	const handleCreateNew = () => {
		window.location.href = "/music?page=add";
	};
	const redirectToMusicPlatform = () => {
		window.location.href = "/managemusicplatform";
	};
	const handleSelectForDelete = (id: any) => {
		setSelectedId(id);
		setShowDeleteModal(true);
	};
	const handleCloseClick = () => {
		setShowDeleteModal(false);
	};
	const handleActiveMusic = async (id: any, status: any) => {
		const data = {
			adminUserId: parseInt(getLoggedUserId()),
			albumId: id,
			isActive: !status,
		};
		setShowModal(true);
		await dispatch(musicsAction.updateMusicVideoStatus(data));
	};

	const handleSort = (sortColumn) => {
		const direction =
			sortColumn === columnSort?.column
				? columnSort?.direction === "desc"
					? "asc"
					: "desc"
				: "desc";
		setColumnSort({ column: sortColumn, direction: direction });
	};

	const handleGetSortColumn = (display, value) => {
		return (
			<div
				className="column-div d-flex"
				onClick={(e) => {
					handleSort(value);
				}}
			>
				{display}
				<img src={updownArrows} alt="updownArrows" />
			</div>
		);
	};

	return (
		<div data-testid="musicsPage" className="musicsPage-list">
			<div className="card-box">
				<div className="card-box-link-back-div">
					<FontAwesomeIcon icon={faChevronLeft} />
					<CardLink
						onClick={() => history.push("/")}
						className="card-box-link-back"
						data-testid="bible-backtolist"
					>
						Back to List
					</CardLink>
				</div>
			</div>
			<div className="card-box">
				<Row className="filter-link-container d-flex gap-1">
					<Col xs="auto">
						<Input
							type="search"
							onChange={(event) => setSearch(event.target.value)}
							className="form-control"
							id="search-filter"
							placeholder="Search albums.."
							value={searchText}
						/>
					</Col>
					<Col xs="auto">
						<FormGroup className="mb-0">
								<Select
									id="statusSelect"
									className="status-select"
									placeholder="Select status"
									isClearable
									options={[
										{
											value: 1,
											label: "Active",
										},
										{
											value: 0,
											label: "Inactive",
										},
									]}
									onChange={(selected) => {
										if (selected) {
											handleChnageStatus(selected.value);
										} else {
											handleChnageStatus("");
										}
									}}
									styles={{
										container: (base) => ({ ...base, minWidth: 150 }),
										clearIndicator: (base) => ({
											...base,
											cursor: "pointer",
										}),
									}}
								/>
						</FormGroup>
					</Col>
					<Col xs="auto">
						<OrderFilter onApply={handleRangeFilter} />
					</Col>
					<Col xs="auto">
						<Button
							id="submit"
							data-testid="manageMusic"
							className="btn-submit-frm"
							onClick={redirectToMusicPlatform}
						>
							Manage Music Platform
						</Button>
					</Col>
					<Col xs="auto">
						<Button
							id="submit"
							data-testid="createNewMusics"
							className="btn-submit-frm"
							onClick={handleCreateNew}
						>
							Create New
						</Button>
					</Col>
				</Row>
			</div>

			<div className="musics-table">
				<table className="table table-hover" data-testid="musicsTable">
					<thead data-testid="musicsTableHead">
						<tr>
							<th scope="col" data-testid="detail-th">
								Details
							</th>
							<th scope="col" data-testid="artistname-th">
								Artist Name
							</th>
							<th scope="col" data-testid="albumname-th">
								Album Name
							</th>
							<th scope="col" data-testid="trackname-th">
								Track Name
							</th>
							<th scope="col" data-testid="date-th">
								Created Date
							</th>
							<th scope="col" data-testid="status-th">
								Status
							</th>
							<th scope="col" data-testid="platform-th">
								Platform(s)
							</th>
							<th scope="col" data-testid="total-click-th">
								{handleGetSortColumn("Total Clicks", "totalclicks")}
							</th>
							<th scope="col" data-testid="unique-click-th">
								{handleGetSortColumn(
									"Unique clicks per user",
									"uniqueclicksperuser"
								)}
							</th>
							<th scope="col" data-testid="guest-click-th">
								{handleGetSortColumn(
									"Guest User Clicks",
									"totalguestuserclicks"
								)}
							</th>
							<th scope="col" data-testid="order-th">
								{handleGetSortColumn("Order No", "orderno")}
							</th>
							<th scope="col" data-testid="delete-th">
								Delete
							</th>
						</tr>
					</thead>
					<tbody data-testid="musicsTableBody">
						{showModal ? (
							<tr>
								<td colSpan={12} className="text-center">
									<Spinner />
								</td>
							</tr>
						) : (
							<>
								{musicsData && musicsData?.items?.musicAlbums?.length > 0 ? (
									musicsData?.items?.musicAlbums?.map((data: any) => (
										<>
											<tr key={data?.albumId}>
												<th scope="row" className="icon-column">
													<a
														href={`/music?id=${data?.albumId}`}
														className="detail-link"
														data-testid="musicDetailButton"
													>
														<FontAwesomeIcon
															size="2x"
															icon={faEdit}
															title="Details"
															cursor="pointer"
															className="detailButton"
														/>
													</a>
												</th>
												<td id="artistName">{data?.artistName}</td>
												<td id="albumName">{data?.albumName}</td>
												<td id="trackName">{data?.trackName}</td>
												<td id="publish">
													{new Date(data?.createdAtUtc).toLocaleDateString()}
												</td>
												<td id="actionswitch" className="text-center">
													<FormGroup switch>
														<Input
															type="switch"
															className="active-switch"
															data-testid="musicUpdateStatus"
															id="activeInactiveSwitch"
															checked={data?.isActive}
															onChange={() =>
																handleActiveMusic(data?.albumId, data?.isActive)
															}
														/>
													</FormGroup>
												</td>
												<td id="platform">
													{data?.links?.length > 0 && (
														<>
															{data.links.slice(0, 2).map((el, i) => (
																<span key={i}>
																	{el.key}
																	{(i < 1 || data.links.length > 2) &&
																	data.links.length > 1
																		? ", "
																		: ""}
																</span>
															))}

															{data.links.length > 2 && (
																<>
																	<span
																		id={`Tooltip-${data.albumId}`}
																		style={{
																			color: "blue",
																			cursor: "pointer",
																			padding: "0 5px",
																		}}
																	>
																		+{data.links.length - 2} more
																	</span>

																	<UncontrolledTooltip
																		placement="top"
																		target={`Tooltip-${data.albumId}`}
																	>
																		<span style={{ fontSize: "13px" }}>
																			{data?.links
																				?.map((el) => el.key)
																				.join(", ")}
																		</span>
																	</UncontrolledTooltip>
																</>
															)}
														</>
													)}
												</td>

												<td id="total-clicks">{data?.totalClicks}</td>
												<td id="unique-clicks">{data?.uniqueUsersClicked}</td>
												<td id="quest-clicks">{data?.totalGuestUserClicks}</td>
												<td id="order">{data?.sortOrder}</td>
												<td className="icon-column">
													<FontAwesomeIcon
														size="2x"
														icon={faTrashAlt}
														data-testid="musicDeleteButton"
														data-bs-toggle="tooltip"
														cursor="pointer"
														data-bs-placement="bottom"
														title="Delete"
														onClick={() => handleSelectForDelete(data?.albumId)}
													/>
												</td>
											</tr>
										</>
									))
								) : (
									<tr>
										<td colSpan={12} className="text-center h6">
											No Data found.
										</td>
									</tr>
								)}
							</>
						)}
					</tbody>
				</table>
			</div>
			<div className="pagination">
				<ReactPaginate
					previousLabel={"<<"}
					nextLabel={">>"}
					breakLabel={"..."}
					pageCount={Math.ceil(+musicsData?.items?.totalCount / 25)}
					marginPagesDisplayed={2}
					pageRangeDisplayed={3}
					onPageChange={(data) => {
						setCurrentPage(data.selected + 1);
						const body = {
							pageNumber: data.selected + 1,
							pageSize: 25,
							searchText: debouncedSearch,
							sortDirection: columnSort?.direction ?? "",
							sortColumn: columnSort?.column ?? "",
							status: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
							fromOrderNo: rangeFilter?.from,
							toOrderNo: rangeFilter?.to,
						};
						setShowModal(true);
						dispatch(musicsAction.musicsGetByfilter(body));
					}}
					containerClassName={"pagination"}
					pageClassName={"page-item"}
					previousClassName={"page-item"}
					breakClassName={"page-item"}
					breakLinkClassName={"page-link"}
					nextClassName={"page-item"}
					pageLinkClassName={"page-link"}
					previousLinkClassName={"page-link"}
					nextLinkClassName={"page-link"}
					activeClassName={"active"}
					forcePage={currentPage - 1}
				/>
			</div>
			<Modal
				isOpen={showDeleteModal}
				backdrop="static"
				centered
				data-testid="deleteModal"
			>
				<ModalHeader>Delete Music</ModalHeader>
				<ModalBody className="modal-body">
					<form name="deleteMusicForm">
						<div className="col-form-label" data-testid="musicsDeleteMessage">
							Deleting this Music will permanently remove. To confirm, please
							click Confirm Delete.
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<Button
						type="button"
						color="secondary"
						data-bs-dismiss="modal"
						onClick={handleCloseClick}
						data-testid="cancelDeleteButton"
					>
						Cancel
					</Button>
					<Button
						type="button"
						color="primary"
						onClick={handleLoadDeleteModal}
						data-testid="confirmDeleteButton"
					>
						Confirm Delete
					</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { musicsData } = state;
	return {
		musicsData,
	};
};

export default connect(mapStateToProps)(MusicsList);
